import { render, staticRenderFns } from "./RatingCategoryCard.vue?vue&type=template&id=903f3bea&scoped=true&"
import script from "./RatingCategoryCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./RatingCategoryCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./RatingCategoryCard.vue?vue&type=style&index=0&id=903f3bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903f3bea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('903f3bea')) {
      api.createRecord('903f3bea', component.options)
    } else {
      api.reload('903f3bea', component.options)
    }
    module.hot.accept("./RatingCategoryCard.vue?vue&type=template&id=903f3bea&scoped=true&", function () {
      api.rerender('903f3bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRating/components/RatingCategoryCard.vue"
export default component.exports